import { initContextWithDrupalBehavior } from '../services/drupal-behavior-service';
import { DRUPAL_BEHAVIOR_STRING__RUSH_MODAL } from './rush-modal';
import { isMobile } from '../services/mql-service';

export class AppointmentHubUrgentCareModal extends DrupalBehavior {
  $rushModal;
  $tabTitlesWrapper;
  $modalTabs;

  onContent(context) {
    this.$rushModal = $(
      once('rush-modal--apt-hub', '.rush-modal', context)
    ).first();

    this.$tabTitlesWrapper = this.$rushModal.find('.tab-titles--wrapper');
    this.$modalTabs = this.$rushModal.find('.uc-modal-tab');

    this.setOpenCloseClickEvents(context);
    this.setUpTabTitles();
    this.setUpTabsContent();

    initContextWithDrupalBehavior(context, DRUPAL_BEHAVIOR_STRING__RUSH_MODAL);
  }

  setOpenCloseClickEvents(context) {
    const $openButton = $(
      once(
        'rush-modal-open-button--apt-hub',
        '.rush-modal--open-button',
        context
      )
    ).first();

    $openButton.on('click', () => {
      this.openModal();
    });
  }

  openModal() {
    this.$modalTabs.scrollTop(0);
    this.setModalTabHeight();
  }

  setModalTabHeight() {
    const $modalTitleWrapper = this.$rushModal
      .find('.rush-modal--title--wrapper')
      .first();
    const offset =
      $modalTitleWrapper.outerHeight() + this.$tabTitlesWrapper.outerHeight();

    let newModalContentHeight = `calc(100% - ${offset}px)`;

    if (isMobile()) {
      newModalContentHeight = `${window.innerHeight - offset}px`;
    }

    this.$modalTabs.css('height', newModalContentHeight);
  }

  setUpTabsContent() {
    const $firstTab = this.$rushModal.find('.uc-modal-tab').first();

    $firstTab.parent().addClass('active');
    $firstTab.addClass('active');
  }

  setUpTabTitles() {
    const $tabTitles = this.$tabTitlesWrapper.find('button');

    $tabTitles.first().addClass('active');

    $tabTitles.each((index, titleElement) => {
      $(titleElement).on('click', () => {
        this.onTitleClick(index, titleElement);
      });
    });
  }

  onTitleClick(titleIndex, titleElement) {
    const $tabElements = $('.uc-modal-tab');

    $(titleElement).siblings().removeClass('active');
    $(titleElement).addClass('active');
    $(titleElement)[0].scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'center',
    });

    $tabElements.parent().removeClass('active');
    $tabElements.removeClass('active');
    $tabElements.eq(titleIndex).parent().addClass('active');
    $tabElements.eq(titleIndex).addClass('active');
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_hub_urgent_care_modal',
  AppointmentHubUrgentCareModal
);
